import axios from 'axios';
import _ from 'lodash';
import { getSlimUser } from "../User/getSlimUser";
import { getSlimGroup } from "./getSlimGroup";
function eventCreatedAt() {
  return Math.floor(new Date().getTime() / 1000);
}
const EventTracker = {
  trackClick: async (eventName, payload, config) => {
    const group = getSlimGroup(config);
    const user = getSlimUser(_.get(config, 'user', {}), group);
    const url = _.get(config, 'url', null);
    if (!url) {
      console.error('EventTracker.trackClick track url undefined.');
      return;
    }
    const data = {
      event: {
        name: eventName,
        created_at: eventCreatedAt()
      },
      payload,
      user,
      group
    };
    try {
      await axios.post("".concat(url, "/events"), data);
      return true;
    } catch (error) {
      console.error('Error tracking event:', error);
      throw error;
    }
  }
};
export default EventTracker;
//# sourceMappingURL=EventTracker.js.map